<script lang="ts" setup>
import { DropdownComp, ModalComp, ButtonComp, ContentComp } from '@/components';
import { $tm } from '@/locize';
import { EngineHandlerView } from '../views';
import { ref, type ComponentInstance } from 'vue';
import { useDialog, useTaskLoader } from '@/composeables';
import { useToastStore, useUserStoreRef } from '@/stores';
import { DropdownItemButton } from '@/objects';

const { user } = useUserStoreRef();
/**
 * The modal reference
 * We use it to show the modal
 */
const engineHandlerModal = ref<ComponentInstance<typeof ModalComp> | null>(null);
const engineHandlerView = ref<ComponentInstance<typeof EngineHandlerView> | null>(null);
const { AddLoader, LoadState } = useTaskLoader();

const reloadInAllEngines = () => {
    useDialog().YesNo({
        title: $tm('enginehandler.reloadinallengines'),
        body: $tm('enginehandler.reloadinallenginesconfirm', '', true),
        yesCallback: async () => {
            AddLoader(async () => {
                await engineHandlerView?.value?.ReloadAllEngines();

                useToastStore().addSuccess($tm('enginehandler.reloadinallenginessuccess'));
            }, 'enginehandler.reloadinallengines');
            return true;
        },
        savestate: LoadState.value,
    });
};

const superAdminMenuDropdownItems = [
    DropdownItemButton.create({
        translationkey: $tm('event.handleengines'),
        icon: 'fa-engine',
        buttonType: 'Custom',
        action: () => engineHandlerModal.value?.show(),
    }),
];
</script>

<template>
    <DropdownComp
        v-if="user?.IsSuperAdmin"
        class="flex-fill"
        icon="fa-cog"
        :title="$tm('header.eventactions')"
        :dropdown-items="superAdminMenuDropdownItems"
    />

    <!-- The modal for the engineHandlers -->
    <ModalComp
        ref="engineHandlerModal"
        title="event.handleengines"
        titleIcon="fa-engine"
        size="xxl"
    >
        <template #content>
            <ContentComp
                :load-state="LoadState"
                :show-as-modal="true"
            >
                <EngineHandlerView ref="engineHandlerView" />
            </ContentComp>
        </template>

        <template #footer>
            <ButtonComp
                button-type="Danger"
                icon="fa-bin-recycle"
                @click="reloadInAllEngines"
            >
                {{ $tm('enginehandler.reloadinallengines') }}
            </ButtonComp>
            <ButtonComp
                button-type="Refresh"
                @click="engineHandlerView?.Refresh()"
                >{{ $tm('button.refresh') }}</ButtonComp
            >
            <ButtonComp
                button-type="Close"
                @click="engineHandlerModal?.hide()"
                >{{ $tm('button.close') }}</ButtonComp
            >
        </template>
    </ModalComp>
</template>
